module.exports = __webpack_public_path__ + "img/anniversary.f9e54e2b.jpg";